module.exports = __webpack_public_path__ + "static/2-d877f3997c1fd8af8e85e0da37a77c8e.jpg";